






























import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { mixins } from "vue-class-component";
import ActionButton from "@/components/Button/ActionButton.vue";
import FscSimpleCard from "@/components/Card/FscSimpleCard.vue";
import LicenseClassRequestMixin from "@/mixins/Request/LicenseClassRequestMixin";
import DrivingLessonTaskGroupCard from "@/views/Configuration/DrivingLessonTaskGroups/DrivingLessonTaskGroupCard.vue";
import DrivingLessonTaskGroupCreateModal from "@/views/Configuration/DrivingLessonTaskGroups/DrivingLessonTaskGroupCreateModal.vue";
import { IDrivingLessonTaskGroup } from "@/interfaces/IDrivingLessonTaskGroup";
import { GFA_GROUP_MANAGEMENT_ENABLED } from "@/constants/DrivingLessonTaskGroup";

const DrivingLessonTaskGroupModule = namespace("driving-lesson-task-group");

@Component({
  components: {
    ActionButton,
    FscSimpleCard,
    DrivingLessonTaskGroupCard,
    DrivingLessonTaskGroupCreateModal,
  },
})
export default class DrivingLessonTaskGroups extends mixins(LicenseClassRequestMixin) {
  public name = "DrivingLessonTaskGroups";

  public gfaGroupManagementEnabled = GFA_GROUP_MANAGEMENT_ENABLED;

  @DrivingLessonTaskGroupModule.Action("findAll")
  public findAllGroups: any;

  @DrivingLessonTaskGroupModule.Getter("getDataList")
  public allGroups: any;

  @DrivingLessonTaskGroupModule.Getter("getIsLoading")
  public loading: any;

  public mounted(): void {
    this.fetchGroups();
    this.findLicenseClassGroupsForCurrentDrivingSchool();
  }

  public get licenseClassOptions(): Array<{ text: string; value: number }> {
    return this.licenseClassGroupsForCurrentDrivingSchool
      .flatMap((group) => group.licenseClasses)
      .map((licenseClass) => ({ text: licenseClass.name as string, value: licenseClass.id as number }));
  }

  public fetchGroups(): void {
    this.findAllGroups({ resource: "driving-lesson-task-groups" });
  }

  public onGroupSaved(payload: { oldId: number; group: IDrivingLessonTaskGroup }): void {
    const index = (this.allGroups || []).findIndex((group: IDrivingLessonTaskGroup) => group.id === payload.oldId);
    if (index === -1) {
      this.fetchGroups();
      return;
    }
    this.allGroups.splice(index, 1, payload.group);
  }

  public showCreateModal(): void {
    this.$bvModal.show("driving-lesson-task-group-create-modal");
  }
}
